import getDateDiffFromNow, {
  getDateFromTimeStamp,
  getTimeFromTimeStamp,
} from './getDateDiffFromNow';
import {
  getKeyValsFromObjArr,
  getLowerCaseString,
} from './getKeyValsFromObjArr';
import getSection, { sanitizeSectionName } from './getSection';
import { PAID_ARTICLE_PRIME_ID } from '../../../constants';
import getChannelName from './getChannelName';

const getGa4PageViewEventObj = (
  pageData = {},
  params = {},
  overrideObj = {},
) => {
  const {
    ag,
    id,
    metaInfo = {},
    dl,
    authors = [],
    navsubsecs = {},
    seo = {},
    primeId,
  } = pageData;

  const {
    pageTemplate,
    isMobile,
    perpetual = false,
    pagination,
    path,
  } = params;
  const { subsecname1 = '', subsecname2 = '', subsecname3 = '' } = getSection(
    navsubsecs,
  );

  let sectionName = subsecname1.toLowerCase();
  let subSectionName = subsecname2.toLowerCase();
  let subSectionName2 = subsecname3.toLowerCase();

  // Replace subsection to section if section is not present
  if (sectionName === '' && subSectionName !== '') {
    sectionName = subSectionName;
    subSectionName = '';
  }
  sectionName = sanitizeSectionName(getLowerCaseString(sectionName));
  subSectionName = sanitizeSectionName(getLowerCaseString(subSectionName));
  subSectionName2 = sanitizeSectionName(getLowerCaseString(subSectionName2));

  const notAvailable = 'N/A';
  const channelName = getChannelName(sectionName, path);

  let ga4PageViewParams = {
    event: 'page_view',
    page_template: pageTemplate,
    agency: getLowerCaseString(ag) || notAvailable,
    section: sectionName || notAvailable,
    subsection: subSectionName || notAvailable,
    subsection2: subSectionName2 || notAvailable,
    msid: id,
    keywords: seo.keywords,
    content_type:
      metaInfo.Contenttype && metaInfo.Contenttype !== ''
        ? getLowerCaseString(metaInfo.Contenttype)
        : notAvailable,
    browsing_client: 'web',
    browsing_platform: isMobile ? 'mweb' : 'web',
    business_property: getLowerCaseString(channelName) || 'toi',
    page_stack: 'react',
    perpetual,
    pagination: pagination || notAvailable,
    days_since_created: dl !== '' ? getDateDiffFromNow(dl) : notAvailable,
    authors:
      getLowerCaseString(getKeyValsFromObjArr(authors, 'name', ',')) ||
      notAvailable,
    page_version: notAvailable,
    meta_tag: seo.keywords,
    prime_content: !!params.isToipLayout,
    is_paywalled: primeId === PAID_ARTICLE_PRIME_ID && !params.isPrime,
    published_time: dl !== '' ? getTimeFromTimeStamp(dl) : notAvailable,
    published_date: dl !== '' ? getDateFromTimeStamp(dl) : notAvailable,
    section_full:
      getLowerCaseString(
        [sectionName, subSectionName, subSectionName2]
          .filter(Boolean)
          .join('_'),
      ) || notAvailable,
    category_tag:
      params.categorytabsmetainfo && params.categorytabsmetainfo !== ''
        ? getLowerCaseString(params.categorytabsmetainfo)
        : notAvailable,
  };
  ga4PageViewParams = { ...overrideObj, ...ga4PageViewParams };
  return ga4PageViewParams;
};

export default getGa4PageViewEventObj;
